import { axios } from '@Root/API'

export const getNotConfirmed = params => {
	return axios.get('get-not-confirmed-students', {
		params,
	})
}
